import { useTranslation } from "react-i18next";
import { UnlockCodeViewModel } from "./UnlockCodeViewModel";
import {
  provideGetCategoryUnlockCodeUseCase,
  provideUnlockCategoryUseCase,
} from "../../di/UseCasesModule";
import { Box, Stack } from "@mui/material";
import { COLOR_GREEN, COLOR_MAIN } from "../../../data/colors/Colors";
import { CustomImageView } from "../../component/CustomImageView";
import { APP_ICON_IMAGE_WITHOUT_TITLE } from "../../../data/constant/Constants";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import { CustomCardView } from "../../component/CustomCardView";
import { CustomTextView } from "../../component/CustomTextView";
import { LoadingView } from "../../component/LoadingView";
import { CheckCircleRounded } from "@mui/icons-material";

export function UnlockCodeView() {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isMobile = width < 900;

  const viewModel = UnlockCodeViewModel(
    provideGetCategoryUnlockCodeUseCase(),
    provideUnlockCategoryUseCase()
  );
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        position: "relative",
        bgcolor: COLOR_MAIN,
      }}
    >
      <CustomImageView
        width={"100%"}
        height={"100%"}
        src={APP_ICON_IMAGE_WITHOUT_TITLE}
        scale={isMobile ? "cover" : "contain"}
        props={{ position: "absolute" }}
      />
      <Stack
        width={"100vw"}
        height={"100vh"}
        alignItems={"center"}
        p={3}
        justifyContent={"center"}
        position={"absolute"}
      >
        <CustomCardView
          minHeight={"45vh"}
          width={isMobile ? "100%" : "50vw"}
          children={
            <Stack
              width={"100%"}
              height={"100%"}
              alignItems={"center"}
              gap={4}
              justifyContent={"center"}
            >
              {viewModel.isLoading ? (
                <LoadingView minHeight="10vh" />
              ) : (
                <>
                  {viewModel.error ? (
                    <CustomTextView
                      text={viewModel.error}
                      textColor="red"
                      variant="h5"
                      fontWeight="bold"
                      textAlign="center"
                    />
                  ) : (
                    <>
                      {viewModel.isCategoryUnlocked && (
                        <Stack gap={1} width={"100%"} alignItems={"center"}>
                          <CheckCircleRounded
                            sx={{ color: COLOR_GREEN, width: 80, height: 80 }}
                          />
                          <CustomTextView
                            text={t("category_unlocked_successfully")}
                            variant="h6"
                            textColor={"green"}
                          />
                        </Stack>
                      )}
                    </>
                  )}
                </>
              )}
            </Stack>
          }
        />
      </Stack>
    </Box>
  );
}
